module.exports = __webpack_public_path__ + "img/gh_346703206506_860.d6664b84.jpg";